import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function GuideSection() {
  const [isGuideLoaded, setIsGuideLoaded] = useState(false);
  const { FiPlay } = FiIcons;

  return (
    <motion.section 
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.2, duration: 0.8 }}
      className="relative z-10 px-2 sm:px-4"
    >
      <div className="max-w-6xl mx-auto">
        {/* Glow Effects - Scaled down for mobile */}
        <div className="absolute -top-20 -left-20 md:-top-40 md:-left-40 w-48 h-48 md:w-96 md:h-96 bg-glow-purple/20 rounded-full blur-[60px] md:blur-[120px] pointer-events-none"></div>
        <div className="absolute -bottom-20 -right-20 md:-bottom-40 md:-right-40 w-48 h-48 md:w-96 md:h-96 bg-glow-cyan/20 rounded-full blur-[60px] md:blur-[120px] pointer-events-none"></div>

        <div className="bg-navy-nav/40 backdrop-blur-3xl rounded-[1.5rem] md:rounded-[2.5rem] p-4 md:p-10 border border-white/10 shadow-2xl relative overflow-hidden group">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-badge"></div>
          
          <div className="mb-6 md:mb-10 flex flex-col md:flex-row md:items-center justify-between gap-4 md:gap-6">
            <div className="text-left">
              <h3 className="text-xl md:text-2xl font-bold text-white mb-2">Interactive Sideways Trade Guide</h3>
              <p className="text-sm md:text-base text-text-body">Identify range-bound markets and avoid false break-outs in real-time.</p>
            </div>
            <div className="flex justify-start md:justify-end">
              <span className="px-3 md:px-4 py-1.5 bg-green-500/10 border border-green-500/20 text-green-400 text-[9px] md:text-[10px] font-bold uppercase tracking-widest rounded-full">Live Status: Active</span>
            </div>
          </div>

          {/* GuideJar Iframe Facade Wrapper with Sideways Embed */}
          <div 
            style={{
              position: 'relative',
              height: 0,
              width: '100%',
              overflow: 'hidden',
              zIndex: 99999,
              borderRadius: '8px md:12px',
              boxSizing: 'border-box',
              paddingBottom: 'calc(46.92532943% + 32px)',
              background: '#050508'
            }}
            className="shadow-2xl border border-white/10 group/embed"
          >
            {!isGuideLoaded ? (
              <div 
                className="absolute inset-0 flex flex-col items-center justify-center bg-navy-deep/80 hover:bg-navy-deep/60 backdrop-blur-sm z-10 cursor-pointer transition-all duration-300" 
                onClick={() => setIsGuideLoaded(true)}
              >
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-gradient-brand flex items-center justify-center shadow-[0_0_20px_rgba(232,75,48,0.4)] md:shadow-[0_0_30px_rgba(232,75,48,0.4)] group-hover/embed:scale-110 transition-all duration-300">
                  <SafeIcon icon={FiPlay} className="text-2xl md:text-3xl text-white ml-2" />
                </div>
                <p className="mt-4 md:mt-6 text-white font-bold tracking-widest uppercase text-[10px] md:text-sm animate-pulse text-center px-4">
                  Click to Load Interactive Sideways Guide
                </p>
              </div>
            ) : (
              <iframe 
                src="https://www.guidejar.com/embed/3e417d93-292b-46d7-98a1-4fdb3c82ef18?type=1&controls=on" 
                width="100%" 
                height="100%" 
                style={{ position: 'absolute', inset: 0 }} 
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" 
                allowFullScreen 
                frameBorder="0"
                title="ProfitLense Sideways Trade Guide"
              ></iframe>
            )}
          </div>

          <div className="mt-8 md:mt-10 flex flex-wrap items-center justify-center gap-x-8 md:gap-x-12 gap-y-4">
            <div className="flex items-center gap-2 md:gap-3">
              <div className="w-2 md:w-2.5 h-2 md:h-2.5 rounded-full bg-brand-pink shadow-[0_0_10px_rgba(232,54,110,0.5)]"></div>
              <span className="text-[9px] md:text-xs text-text-body font-bold uppercase tracking-widest">Range Logic</span>
            </div>
            <div className="flex items-center gap-2 md:gap-3">
              <div className="w-2 md:w-2.5 h-2 md:h-2.5 rounded-full bg-brand-secondary shadow-[0_0_10px_rgba(30,144,255,0.5)]"></div>
              <span className="text-[9px] md:text-xs text-text-body font-bold uppercase tracking-widest">Chop Filters</span>
            </div>
            <div className="flex items-center gap-2 md:gap-3">
              <div className="w-2 md:w-2.5 h-2 md:h-2.5 rounded-full bg-brand-primary shadow-[0_0_10px_rgba(232,75,48,0.5)]"></div>
              <span className="text-[9px] md:text-xs text-text-body font-bold uppercase tracking-widest">Capital Preservation</span>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
}